<!--
 * @Description: 分销记录
 * @Author: xiawenlong
 * @Date: 2022-01-19 10:27:27
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-01-19 10:27:27
-->
<template>
  <div class="dist-record">
    <table-list
      title="分销记录"
      :loading="loading"
      :data="dataList"
      :search-form="searchForm"
      :columns="columns(this)"
      :btns="btns(this)"
      :pager="pager"
      :options="{ selection: true }"
      @search="onSearch"
      @selectionChange="handleSelectionChange"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></table-list>
  </div>
</template>

<script>
import TableList from '@/components/TableList'
import { distributeRecordList, distributeRecordExport } from '@/api/distribute'
import to from 'await-to'

// 导出按钮
const btns = _this => [
  {
    label: '导出',
    type: 'primary',
    method: _this.handleExport,
  },
]

// 搜索表单配置
const searchForm = [
  {
    label: '商品类型',
    prop: 'productResourceType',
    type: 'select',
    clearable: true,
    children: [
      { value: 2, label: '课程' },
      { value: 3, label: '证书' },
    ],
  },
  {
    label: '商品名称',
    prop: 'productName',
  },
  {
    label: '分销员姓名',
    prop: 'agentUserName',
  },
  {
    label: '购买人姓名/账号',
    prop: 'userFilter',
  },
  {
    label: '支付时间',
    prop: 'payTime',
    type: 'picker',
  },
]

// 表格列配置
const columns = () => [
  {
    prop: 'orderIdDetail',
    label: '订单编号',
    minWidth: 150,
  },
  {
    prop: 'productResourceType',
    label: '类型',
    minWidth: 70,
    formatter: row => {
      return { 1: '班级', 2: '课程', 3: '证书' }[row.productResourceType]
    },
  },
  {
    prop: 'productName',
    label: '商品名称',
    minWidth: 120,
  },
  {
    prop: 'skuName',
    label: '服务名称',
    minWidth: 120,
  },
  {
    prop: 'onLineShow',
    label: '来源',
    minWidth: 70,
  },
  {
    prop: 'agentUserName',
    label: '分销员',
    minWidth: 90,
  },
  {
    prop: 'userName',
    label: '购买人姓名',
    minWidth: 110,
  },
  {
    prop: 'phone',
    label: '手机号',
    minWidth: 120,
  },
  {
    prop: 'productSumAmount',
    label: '订单金额',
    minWidth: 100,
    align: 'right',
    formatter: row => {
      return `￥${row.productSumAmount}`
    },
  },
  {
    prop: 'amount',
    label: '实付金额',
    minWidth: 100,
    align: 'right',
    formatter: row => {
      return `￥${row.amount}`
    },
  },
  {
    prop: 'payTypeName',
    label: '支付渠道',
    minWidth: 90,
  },
  {
    prop: 'payTimeShow',
    label: '支付时间',
    minWidth: 160,
  },
]

export default {
  name: 'DistRecord',
  components: {
    TableList,
  },
  data() {
    return {
      btns,
      searchForm,
      columns,
      loading: false,
      dataList: [],
      queryParams: {},
      pager: {
        total: 0,
        size: 10,
        current: 1,
      },
      selectItems: [],
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    async getList() {
      if (this.loading) return
      const { current, size } = this.pager
      this.loading = true
      const [res, err] = await to(distributeRecordList({ current, size, ...this.queryParams }))
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.dataList = res.data.list || []
      this.pager.total = res.data.total || 0
    },
    onSearch(queryParams) {
      this.pager.current = 1
      if (queryParams.payTime) {
        queryParams.payTimeStart = queryParams.payTime[0]
        queryParams.payTimeEnd = queryParams.payTime[1].split(' ')[0] + ' 23:59:59'
      } else {
        queryParams.payTimeStart = ''
        queryParams.payTimeEnd = ''
      }
      this.queryParams = queryParams
      this.getList()
    },
    async handleExport() {
      let ids = []
      this.selectItems.map(v => ids.push(v.id))
      const { current, size } = this.pager
      const [res, err] = await to(
        distributeRecordExport({ current, size, ...this.queryParams, ids }),
      )
      if (err) return this.$message.warning(err.msg)
      let blob = new Blob([res], {
        type: 'application/vnd.ms-excel',
      })
      let url = window.URL.createObjectURL(blob)
      let a = document.createElement('a')
      a.href = url
      a.download = '分销记录.xlsx'
      a.click()
      window.URL.revokeObjectURL(url)
    },
    handleSelectionChange(val) {
      this.selectItems = val
    },
    handleSizeChange(size) {
      this.pager.current = 1
      this.pager.size = size
      this.getList()
    },
    handleCurrentChange(current) {
      this.pager.current = current
      this.getList()
    },
  },
}
</script>

<style lang="scss" scoped>
.dist-record {
  height: 100%;
}
</style>
